"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { authService } from "@/lib/services/auth";

export default function RootPage() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is authenticated with server validation
    const checkAuthAndRedirect = async () => {
      try {
        setIsLoading(true);
        
        // Use enhanced authentication check that validates token on server
        const isAuthenticated = await authService.isAuthenticatedWithValidation();
        
        if (isAuthenticated) {
          // User is authenticated with valid credentials, redirect to dashboard
          if (process.env.NEXT_PUBLIC_ENV === 'development') {
            console.log('User authenticated with valid credentials, redirecting to dashboard');
          }
          router.replace("/dashboard");
        } else {
          // User is not authenticated or has invalid credentials, redirect to login
          if (process.env.NEXT_PUBLIC_ENV === 'development') {
            console.log('User not authenticated or has invalid credentials, redirecting to login');
          }
    router.replace("/login");
        }
      } catch (error) {
        if (process.env.NEXT_PUBLIC_ENV === 'development') console.error('Error checking authentication:', error);
        // On error, clear invalid credentials and redirect to login
        authService.clearInvalidCredentials(router);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthAndRedirect();
  }, [router]);

  return (
    <div className="flex items-center justify-center min-h-screen w-full bg-canvas-alt">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-inversePurple-100 mx-auto mb-4"></div>
        <p className="text-lg font-semibold text-muted">
          {isLoading ? 'Validating credentials...' : 'Loading InversePay Dashboard...'}
        </p>
      </div>
    </div>
  );
} 